import { CampaignChannel } from '../types/campaigns'

export interface TemplateStarter {
  id: string
  name: string
  description: string
  icon: string
  channel: CampaignChannel
  preview: string // Base64 or URL to preview image
  content: {
    subject: string
    bodyHtml: string
    bodyText: string
    variables: string[]
  }
}

export const TEMPLATE_STARTERS: TemplateStarter[] = [
  {
    id: 'newsletter',
    name: 'Newsletter Simple',
    description: 'Perfect for regular updates, company news, and blog posts',
    icon: '📧',
    channel: 'EMAIL' as CampaignChannel,
    preview: '', // Will add preview image later
    content: {
      subject: 'Your {{companyName}} Newsletter - {{month}} Edition',
      variables: ['firstName', 'companyName', 'month'],
      bodyText: `Hi {{firstName}},\n\nWelcome to our latest newsletter!\n\n[Main content here]\n\nBest regards,\nThe {{companyName}} Team`,
      bodyHtml: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Newsletter</title>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f4f4f4;">
  <table width="100%" cellpadding="0" cellspacing="0" border="0">
    <tr>
      <td align="center" style="padding: 40px 0;">
        <table width="600" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
          
          <!-- Header -->
          <tr>
            <td align="center" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 40px 20px;">
              <h1 style="color: #ffffff; margin: 0; font-size: 28px; font-weight: bold;">{{companyName}}</h1>
              <p style="color: #ffffff; margin: 10px 0 0 0; font-size: 14px; opacity: 0.9;">Your Monthly Newsletter</p>
            </td>
          </tr>
          
          <!-- Body -->
          <tr>
            <td style="padding: 40px 30px;">
              <p style="color: #333333; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                Hi <strong>{{firstName}}</strong>,
              </p>
              
              <p style="color: #666666; font-size: 16px; line-height: 1.6; margin: 0 0 30px 0;">
                Welcome to our latest newsletter! We're excited to share what's new with you this month.
              </p>
              
              <!-- Featured Section -->
              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom: 30px;">
                <tr>
                  <td style="background-color: #f8f9fa; border-radius: 8px; padding: 30px;">
                    <h2 style="color: #333333; font-size: 22px; margin: 0 0 15px 0;">Featured Update</h2>
                    <p style="color: #666666; font-size: 15px; line-height: 1.6; margin: 0;">
                      Add your main content here. This could be a featured article, product announcement, or important update.
                    </p>
                  </td>
                </tr>
              </table>
              
              <!-- Secondary Content -->
              <h3 style="color: #333333; font-size: 18px; margin: 0 0 15px 0;">What's New</h3>
              <ul style="color: #666666; font-size: 15px; line-height: 1.8; margin: 0 0 30px 0; padding-left: 20px;">
                <li>Update item 1</li>
                <li>Update item 2</li>
                <li>Update item 3</li>
              </ul>
              
              <p style="color: #666666; font-size: 16px; line-height: 1.6; margin: 0;">
                Best regards,<br>
                <strong>The {{companyName}} Team</strong>
              </p>
            </td>
          </tr>
          
          <!-- Footer -->
          <tr>
            <td style="background-color: #f8f9fa; padding: 30px; text-align: center; border-top: 1px solid #e9ecef;">
              <p style="color: #999999; font-size: 12px; margin: 0 0 10px 0;">
                © 2024 {{companyName}}. All rights reserved.
              </p>
              <p style="color: #999999; font-size: 12px; margin: 0;">
                <a href="{{unsubscribe_url}}" style="color: #667eea; text-decoration: none;">Unsubscribe</a>
              </p>
            </td>
          </tr>
          
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
      `.trim(),
    },
  },
  {
    id: 'promotional',
    name: 'Promotional',
    description: 'Eye-catching design for sales, discounts, and special offers',
    icon: '🎉',
    channel: 'EMAIL' as CampaignChannel,
    preview: '',
    content: {
      subject: '🎉 Special Offer: {{discountPercent}}% OFF - Limited Time!',
      variables: ['firstName', 'discountPercent', 'promoCode', 'expiryDate'],
      bodyText: `Hi {{firstName}},\n\nDon't miss out! Get {{discountPercent}}% OFF with code {{promoCode}}\n\nOffer expires: {{expiryDate}}\n\nShop now!`,
      bodyHtml: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Special Offer</title>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f4f4f4;">
  <table width="100%" cellpadding="0" cellspacing="0" border="0">
    <tr>
      <td align="center" style="padding: 40px 0;">
        <table width="600" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
          
          <!-- Banner -->
          <tr>
            <td align="center" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); padding: 50px 20px;">
              <h1 style="color: #ffffff; margin: 0; font-size: 36px; font-weight: bold; text-transform: uppercase; letter-spacing: 2px;">
                Special Offer
              </h1>
              <p style="color: #ffffff; margin: 15px 0 0 0; font-size: 18px; font-weight: 500;">
                Limited Time Only!
              </p>
            </td>
          </tr>
          
          <!-- Body -->
          <tr>
            <td style="padding: 50px 30px; text-align: center;">
              <p style="color: #333333; font-size: 18px; margin: 0 0 30px 0;">
                Hi <strong>{{firstName}}</strong>,
              </p>
              
              <!-- Discount Badge -->
              <div style="display: inline-block; background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); border-radius: 50%; width: 150px; height: 150px; margin: 0 auto 30px;">
                <table width="150" height="150" cellpadding="0" cellspacing="0">
                  <tr>
                    <td align="center" valign="middle">
                      <div style="color: #ffffff; font-size: 48px; font-weight: bold; line-height: 1;">{{discountPercent}}%</div>
                      <div style="color: #ffffff; font-size: 16px; font-weight: 500; margin-top: 5px;">OFF</div>
                    </td>
                  </tr>
                </table>
              </div>
              
              <h2 style="color: #333333; font-size: 28px; margin: 0 0 20px 0; font-weight: bold;">
                Don't Miss Out!
              </h2>
              
              <p style="color: #666666; font-size: 16px; line-height: 1.6; margin: 0 0 30px 0;">
                Use promo code <strong style="color: #f5576c; font-size: 20px;">{{promoCode}}</strong> at checkout
              </p>
              
              <!-- CTA Button -->
              <table cellpadding="0" cellspacing="0" border="0" align="center" style="margin: 0 auto 30px;">
                <tr>
                  <td align="center" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); border-radius: 50px; padding: 18px 50px;">
                    <a href="#" style="color: #ffffff; text-decoration: none; font-size: 18px; font-weight: bold; display: block;">
                      Shop Now
                    </a>
                  </td>
                </tr>
              </table>
              
              <p style="color: #999999; font-size: 14px; margin: 0;">
                Offer expires: <strong>{{expiryDate}}</strong>
              </p>
            </td>
          </tr>
          
          <!-- Terms -->
          <tr>
            <td style="background-color: #f8f9fa; padding: 20px 30px; border-top: 1px solid #e9ecef;">
              <p style="color: #999999; font-size: 11px; line-height: 1.5; margin: 0; text-align: center;">
                *Terms and conditions apply. Cannot be combined with other offers. Valid for one-time use only.
              </p>
            </td>
          </tr>
          
          <!-- Footer -->
          <tr>
            <td style="background-color: #f8f9fa; padding: 20px 30px; text-align: center;">
              <p style="color: #999999; font-size: 12px; margin: 0;">
                <a href="{{unsubscribe_url}}" style="color: #f5576c; text-decoration: none;">Unsubscribe</a>
              </p>
            </td>
          </tr>
          
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
      `.trim(),
    },
  },
  {
    id: 'informational',
    name: 'Informational',
    description: 'Clean layout for announcements, updates, and educational content',
    icon: '📰',
    channel: 'EMAIL' as CampaignChannel,
    preview: '',
    content: {
      subject: 'Important Update: {{updateTitle}}',
      variables: ['firstName', 'updateTitle', 'companyName'],
      bodyText: `Hi {{firstName}},\n\nWe wanted to inform you about: {{updateTitle}}\n\n[Details here]\n\nBest regards,\n{{companyName}}`,
      bodyHtml: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Important Update</title>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f4f4f4;">
  <table width="100%" cellpadding="0" cellspacing="0" border="0">
    <tr>
      <td align="center" style="padding: 40px 0;">
        <table width="600" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
          
          <!-- Header -->
          <tr>
            <td style="background-color: #2c3e50; padding: 30px; border-bottom: 4px solid #3498db;">
              <h1 style="color: #ffffff; margin: 0; font-size: 24px; font-weight: 600;">{{companyName}}</h1>
              <p style="color: #ecf0f1; margin: 8px 0 0 0; font-size: 14px;">Important Update</p>
            </td>
          </tr>
          
          <!-- Body -->
          <tr>
            <td style="padding: 40px 30px;">
              <p style="color: #333333; font-size: 16px; margin: 0 0 20px 0;">
                Hi <strong>{{firstName}}</strong>,
              </p>
              
              <h2 style="color: #2c3e50; font-size: 24px; margin: 0 0 20px 0; font-weight: 600; border-left: 4px solid #3498db; padding-left: 15px;">
                {{updateTitle}}
              </h2>
              
              <p style="color: #555555; font-size: 15px; line-height: 1.7; margin: 0 0 25px 0;">
                We wanted to inform you about an important update. Please read the following information carefully.
              </p>
              
              <!-- Key Points -->
              <div style="background-color: #f8f9fa; border-left: 4px solid #3498db; padding: 20px; margin: 0 0 25px 0; border-radius: 4px;">
                <h3 style="color: #2c3e50; font-size: 18px; margin: 0 0 15px 0; font-weight: 600;">Key Points:</h3>
                <ul style="color: #555555; font-size: 15px; line-height: 1.8; margin: 0; padding-left: 20px;">
                  <li>Important point number one</li>
                  <li>Important point number two</li>
                  <li>Important point number three</li>
                </ul>
              </div>
              
              <!-- Additional Section -->
              <h3 style="color: #2c3e50; font-size: 18px; margin: 0 0 15px 0; font-weight: 600;">What This Means for You</h3>
              <p style="color: #555555; font-size: 15px; line-height: 1.7; margin: 0 0 25px 0;">
                Add detailed explanation here about how this update affects your users or customers.
              </p>
              
              <!-- Action Items -->
              <div style="background-color: #e8f4f8; border: 1px solid #3498db; padding: 20px; margin: 0 0 25px 0; border-radius: 4px;">
                <h3 style="color: #2c3e50; font-size: 18px; margin: 0 0 15px 0; font-weight: 600;">📋 Action Required:</h3>
                <p style="color: #555555; font-size: 15px; line-height: 1.7; margin: 0;">
                  Please review this information and take any necessary actions by the specified deadline.
                </p>
              </div>
              
              <!-- CTA Button (Optional) -->
              <table cellpadding="0" cellspacing="0" border="0" align="center" style="margin: 0 auto 25px;">
                <tr>
                  <td align="center" style="background-color: #3498db; border-radius: 4px; padding: 15px 40px;">
                    <a href="#" style="color: #ffffff; text-decoration: none; font-size: 16px; font-weight: 600; display: block;">
                      Learn More
                    </a>
                  </td>
                </tr>
              </table>
              
              <p style="color: #555555; font-size: 15px; line-height: 1.7; margin: 0;">
                If you have any questions, please don't hesitate to contact us.
              </p>
              
              <p style="color: #555555; font-size: 15px; line-height: 1.7; margin: 20px 0 0 0;">
                Best regards,<br>
                <strong>{{companyName}} Team</strong>
              </p>
            </td>
          </tr>
          
          <!-- Footer -->
          <tr>
            <td style="background-color: #f8f9fa; padding: 25px 30px; text-align: center; border-top: 1px solid #e9ecef;">
              <p style="color: #999999; font-size: 12px; margin: 0 0 10px 0;">
                © 2024 {{companyName}}. All rights reserved.
              </p>
              <p style="color: #999999; font-size: 12px; margin: 0;">
                <a href="{{unsubscribe_url}}" style="color: #3498db; text-decoration: none;">Unsubscribe</a>
              </p>
            </td>
          </tr>
          
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
      `.trim(),
    },
  },
]
